// extracted by mini-css-extract-plugin
export default {"container":"hNl9my","page":"GxH_UU"};